import { useContext } from "react";

import { AppProviderContext } from "../../providers/AppProvider";

export const useFileProvider = () =>
  useContext(AppProviderContext).fileProvider;
